<template>
  <v-tooltip
    open-delay=1000
    :left="tooltipLeft"
    :right="tooltipRight"
    :top="tooltipTop"
    :bottom="tooltipBottom"
    >
    <template v-slot:activator="{ on }">
      <span v-on="on" v-if="enableToolTip">
        <div>
          <v-row v-if="label !== ''" no-gutters class="form-group">
            <span v-if="label !== ''" class="item-label">{{ label }}</span>
            <label class="form-group-label">
              <span v-if="required" class="mandatory">必須</span>
            </label>
          </v-row>
          <v-select
            v-bind="computedProps"
            v-on="computedListeners"
            label=""
            solo
            flat
            :placeholder="phtext"
            :clearable="clearable"
            multiple
            :tabindex="readonly ? -1 : 0"
          >
            <template v-slot:append-outer v-if="appendOuterIcon !== null">
              <v-btn small icon color="#83bde5" class="append-outer-btn" @click="onClickAppendOuterIcon"><v-icon>{{ appendOuterIcon }}</v-icon></v-btn>
            </template>
            <template v-slot:selection="{ item, index }">
              <v-chip small v-if="index < dispChipCount">
                <span>{{ item.text }}</span>
              </v-chip>
              <span
                v-if="index===dispChipCount"
                class="grey--text text-caption"
              >
                (+{{ value.length - dispChipCount }} 件選択中)
              </span>
            </template>
          </v-select>
        </div>
      </span>
      <div v-else>
        <v-row v-if="label !== ''" no-gutters class="form-group">
          <span v-if="label !== ''" class="item-label">{{ label }}</span>
          <label class="form-group-label">
            <span v-if="required" class="mandatory">必須</span>
          </label>
        </v-row>
        <v-select
          v-bind="computedProps"
          v-on="computedListeners"
          solo
          flat
          :placeholder="phtext"
          multiple
          :clearable="clearable"
          :tabindex="readonly ? -1 : 0"
        >
          <template v-slot:label v-if="label !== undefined && label !== null && label !== ''">
            {{ label }}
            <span v-if="required" class="mandatory">必須</span>
          </template>
          <template v-slot:append-outer v-if="appendOuterIcon !== null">
            <v-btn small icon color="#83bde5" class="append-outer-btn" @click="onClickAppendOuterIcon"><v-icon>{{ appendOuterIcon }}</v-icon></v-btn>
          </template>
          <template v-slot:selection="{ item, index }">
            <v-chip small v-if="index < dispChipCount">
              <span>{{ item.text }}</span>
            </v-chip>
            <span
              v-if="index===dispChipCount"
              class="grey--text text-caption"
            >
              (+{{ value.length - dispChipCount }} 件選択中)
            </span>
          </template>
        </v-select>
      </div>
    </template>
    <span v-html="tooltipText"></span>
  </v-tooltip>
</template>
<script>
import controls from '@/rahmen/controls'
import validators from '@/rahmen/validators'
import inputMixin from '@/mixins/inputMixins'
import { VSelect } from 'vuetify/lib'

/**
 * @file DDv2用複数ドロップダウン
 * @namespace components
 */

/**
 * @vue-prop {Boolean} [required=false] - 必須有無
 * @vue-prop {String} [errorMessages=''] - エラーメッセージ
 * @see https://vuetifyjs.com/ja/api/v-select/
 * @example
  <dd-drop-down
    v-model="dropdown1value"
    :items="dropDownItems"
    :required="true"
    />
  data: () => ({
    dropDownItems: [
      { value: null, text: '' },
      { value: '0', text: 'Windows 3.1' },
      { value: '1', text: 'Windows 95' },
      { value: '2', text: 'Windows 98' },
      { value: '3', text: 'Windows 98 SE' },
      { value: '4', text: 'Windows 2000' },
      { value: '5', text: 'Windows Me' },
      { value: '6', text: 'Windows XP' },
      { value: '7', text: 'Windows Vista' },
      { value: '8', text: 'Windows 8' },
      { value: '9', text: 'Windows 10' }
    ]
  })
 */
export default {
  name: 'DdDropDownMulti',
  extends: VSelect,
  mixins: [inputMixin],
  props: {
    /**
     * 必須指定
     */
    required: Boolean,
    /**
     * 表示エラーメッセージ
     */
    errorMessages: String,
    /**
     * ラベル
     */
    label: {
      type: String,
      default: ''
    },
    /**
     * ツールチップテキスト
     */
    tooltipText: {
      type: String,
      default: ''
    },
    /**
     * ツールチップ表示要否
     */
    enableToolTip: {
      type: Boolean,
      default: false
    },
    /**
     * ツールチップ表示位置（左）
     */
    tooltipLeft: {
      type: Boolean,
      default: true
    },
    /**
     * ツールチップ表示位置（上）
     */
    tooltipTop: {
      type: Boolean,
      default: false
    },
    /**
     * ツールチップ表示位置（右）
     */
    tooltipRight: {
      type: Boolean,
      default: false
    },
    /**
     * ツールチップ表示位置（下）
     */
    tooltipBottom: {
      type: Boolean,
      default: false
    },
    /**
     * 後方アイコン
     */
    appendOuterIcon: {
      type: String,
      default: null
    },
    /**
     * チップの表示数
     */
    dispChipCount: {
      type: Number,
      default: 3
    },
    /**
     * 未選択時、全件選択モード(検索画面で使用)
     * 検索条件として使う場合など、未選択だと全件対象となるようなときにtrueに設定する。
     * trueのときは、以下のような動きになる。
     * ・項目が選択されずにメニューをとじた場合、全選択状態になる。
     */
    searchSceneMode: {
      type: Boolean,
      default: true
    },
    /**
     * クリアボタンを表示するか否か
     */
    clearable: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    phtext: '選択して下さい',
    invalidMessage: ''
  }),
  created () {
  },
  mounted () {
    console.log(this.$props)
    this.invalidMessage = this.errorMessages
  },
  computed: {
    computedProps () {
      return {
        ...this.$props,
        // backgroundColor: this.required ? controls.Colors.Required : '',
        class: this.required ? ' required-item' : this.class,
        hideDetails: 'auto',
        dense: true,
        error: this.hasError,
        errorMessages: this.invalidMessage,
        itemText: controls.SelectTextPropName,
        itemValue: controls.SelectValuePropName
      }
    },
    computedListeners () {
      return {
        ...this.$listeners,
        blur: e => this.onBlur(e)
      }
    },
    hasError () {
      return this.invalidMessage !== '' && this.invalidMessage !== undefined
    },
    selectedAllItems () {
      if (!this.value) {
        return false
      } else {
        return Boolean(this.value.length === this.allItems.length)
      }
    },
    selectedSomeItems () {
      if (!this.value) {
        return false
      } else {
        return Boolean(this.value.length > 0 && !this.selectedAllItems)
      }
    },
    icon () {
      if (this.selectedAllItems) return 'mdi-close-box'
      if (this.selectedSomeItems) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    }
  },
  methods: {
    onBlur: function (e) {
      this[controls.VALIDATE_METHOD]()
      if (!this.hasError) {
        this[controls.FORMAT_METHOD]()
      }
    },

    cancelSelect: function (index) {
      const delIdx = this.value.findIndex((x) => x.index === index)
      if (delIdx >= 0) {
        console.log('removeFile', index, delIdx)
        this.value.splice(delIdx, 1)
      }
    },

    [controls.VALIDATE_METHOD]: function () {
      const target = {
        value: this.value,
        length: this.length
      }

      this.invalidMessage = undefined
      const validatorList = []

      if (this.required) { validatorList.unshift(validators.requireValidate) }
      if (this.appendValidators) { validatorList.push(...this.appendValidators) }

      for (let i = 0; i < validatorList.length; i++) {
        const f = validatorList[i]
        const ret = f(target)
        if (ret !== undefined) {
          this.invalidMessage = ret
          return
        }
      }
    },
    [controls.FORMAT_METHOD]: function () {
    },
    onClickAppendOuterIcon: function () {
      this.$emit('clickAppendOuterIcon')
    }
  }
}
</script>
<style scoped>
::v-deep .v-select__selections input {
  max-width: 0px;
  max-height: 0px;
}
::v-deep .v-input__append-outer {
  margin-top: 4px !important;
  margin-left: 0px !important;
}
.append-outer-btn {
  padding-left:0px !important;
  padding-right:0px !important;
  min-width: 20px !important;
}
</style>
